export default {
  title: "E-Mail verifizieren",
  verifying: {
    title: "Ihre E-Mail wird verifiziert",
    subtitle: "Bitte warten Sie, während wir Ihre E-Mail-Adresse verifizieren...",
  },
  sending: {
    title: "Verifizierungs-E-Mail wird gesendet",
    subtitle: "Bitte warten Sie, während wir die Verifizierungs-E-Mail senden...",
  },
  sent: {
    title: "Verifizierungs-E-Mail gesendet",
    confirmationMessage: {
      beforeEmail: "Wir haben einen Bestätigungslink an ",
      afterEmail: " gesendet",
    },
    instruction:
      "Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Link, um Ihr Konto zu aktivieren",
    troubleMessage:
      "Keine E-Mail erhalten? Überprüfen Sie Ihren Spam-Ordner oder klicken Sie unten auf „Erneut senden“",
    limitNote: "Hinweis: Sie können die Verifizierungs-E-Mail bis zu 3 Mal pro Tag erneut senden",
  },
  resent: {
    title: "Verifizierungs-E-Mail erneut gesendet",
    confirmationMessage: {
      beforeEmail: "Wir haben den Bestätigungslink erneut an ",
      afterEmail: " gesendet",
    },
    instruction:
      "Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Link, um Ihr Konto zu aktivieren",
    troubleMessage:
      "Falls immer noch nicht erhalten, überprüfen Sie Spam/Unbekannt oder versuchen Sie es später erneut",
    limitNote: "Hinweis: Sie können die Verifizierungs-E-Mail bis zu 3 Mal pro Tag erneut senden",
  },
  success: {
    title: "E-Mail erfolgreich verifiziert",
    subtitle: "Ihre E-Mail wurde verifiziert. Sie können sich jetzt bei Ihrem Konto anmelden.",
    button: "Zur Anmeldung gehen",
    autoRedirectMessage: "Weiterleitung zum Dashboard in {seconds} Sekunden...",
  },
  error: {
    title: "E-Mail-Verifizierung fehlgeschlagen",
    subtitle:
      "Bei der Verifizierung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
  },
  resending: "Wird erneut gesendet...",
  resendAvailableIn: "Erneutes Senden in {seconds}s verfügbar",
  resendVerificationEmail: "Verifizierungs-E-Mail erneut senden",
  verificationFailed: "E-Mail-Verifizierung fehlgeschlagen",
  verificationError: "Bei der E-Mail-Verifizierung ist ein Fehler aufgetreten",
  pleaseWait: "Bitte warten Sie {seconds} Sekunden vor dem erneuten Senden",
  dailyLimitReached: "Tägliches Versandlimit erreicht. Morgen erneut versuchen.",
  resentSuccess: "Verifizierungs-E-Mail erfolgreich erneut gesendet",
  resendFailed: "Erneutes Senden der Verifizierungs-E-Mail fehlgeschlagen",
  invalidRequest: "Ungültige Anfrage",
  remainingAttempts: "Sie haben heute noch {count} Versuche übrig",
};
